import { createTheme } from '@mui/material/styles';
import { rgba, border } from 'polished';
import breakpoints from './breakpoints';
import components from './components';
import hexToRGBA from './hexToRGBA';
import palette from './palette';
import pxToEm from './pxToEm';
import pxToRem from './pxToRem';
import shadows from './shadows';
import { CThemeOptions } from './theme.d';
import unitsToRem from './unitsToRem';

const themeOptions: CThemeOptions = {
  palette,
  components,
  pxToEm,
  pxToRem,
  // @ts-expect-error // TODO: fix types
  unitsToRem,
  hexToRGBA,
  rgba,
  border,
  breakpoints,
  shadows,
  typography: {
    fontFamily: 'Graphik',
  },
};

type Theme = typeof theme;
const theme = createTheme(themeOptions);

export {
  Theme,
  theme,
  themeOptions,
  breakpoints,
  components,
  hexToRGBA,
  palette,
  pxToEm,
  pxToRem,
  shadows,
  unitsToRem,
};
